export default __webpack_public_path__ + "static/media/ic_share_24px.ebf65c1f.svg";